import React, { useContext, useEffect } from "react";
import NavBar from "./components/common/NavBar/NavBar";
import { Outlet, useNavigate } from "react-router-dom";
import { AuthContext } from "./context/AuthContext";
import { ROUTES } from "./constants/Routes";
import axios from "axios";
import { API_ROUTES } from "./constants/API_ROUTES";
import { initFlowbite } from "flowbite";

const Layout = () => {
  useEffect(() => {
    initFlowbite();
  }, []);
  return (
    <>
      <header className="fixed top-0 z-50 w-full">
        <NavBar />
      </header>
      <main className="my-[6.5rem] ">
        <Outlet />
      </main>
    </>
  );
};

export default Layout;
